export interface KankorForm {
  prefix: string
  first_name: string
  last_name: string
  birth_date: string
  gender_id: string
  nationality_id: string
  email: string
  contact_number: string
  permanent_country_id: string
  permanent_city: string
  permanent_address: string
  permanent_zip_code: string
  section_id: string
  photo: string
  program_id: string
  academic_year_id: string
  intake_id: string
  study_mode: string
  sponsor_type: string
  campus_id: string
  confirmation_msg: boolean
  confirmation_msg2: boolean
  desired_level: string
  how_did_you_hear: string
}

export const initialValues: KankorForm = {
  prefix: '',
  first_name: '',
  last_name: '',
  birth_date: '',
  gender_id: '',
  nationality_id: '',
  email: '',
  contact_number: '',
  permanent_country_id: '',
  permanent_city: '',
  permanent_address: '',
  permanent_zip_code: '',
  section_id: '',
  photo: '',
  program_id: '',
  academic_year_id: '',
  intake_id: '',
  study_mode: '',
  sponsor_type: '',
  campus_id: '',
  confirmation_msg: false,
  confirmation_msg2: false,
  desired_level: '',
  how_did_you_hear: '',
}
